import type { ReactNode } from 'react';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../../ui/accordion';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

export function ProductAccordion({ title, children }: { title: string; children: ReactNode }) {
  return (
    <Accordion
      type="single"
      collapsible
      className={cn('flex w-full flex-col items-start justify-start border-none p-0')}
    >
      <AccordionItem
        value="content"
        className={cn(
          'flex w-full flex-col items-start justify-start border-none p-0',
          'ea-product-accordion__item',
        )}
      >
        <AccordionTrigger
          className={cn(
            'flex w-full items-center justify-between border-none p-0',
            'ea-product-accordion__trigger',
          )}
        >
          <HtmlRendererRaw
            as="span"
            html={title}
            className="h4 w-full flex-1 text-left font-bold tracking-tighter text-black"
          />
        </AccordionTrigger>
        <AccordionContent className="w-full border-none p-0 pt-3">{children}</AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
